// extracted by mini-css-extract-plugin
export default {"container":"BX-z","title":"CX-z","link":"DX-z"};